import React from 'react';
import { QuizOption } from '../../../types/cards';
import './MultiChoiceRowContent.css';
import {pushInfoToGoogleData} from "../../../utils/googleTag";
import {facebookEventFire} from "../../../utils/facebookEventFire";

interface QuizSelectorProps {
    options: QuizOption[];
    onSelect: (values: string[]) => void;
    selectedValues: string[];
    multiple: boolean;
    stepId: string | number;
    stepIndex: number;
    cardTitle: string;
    step: any;
}

export const MultiChoiceRowContent: React.FC<QuizSelectorProps> = ({
    options,
    onSelect,
    selectedValues,
    multiple,
    stepId,
    stepIndex,
    cardTitle
}) => {
    const handleSelect = (value: string) => {

        if (multiple) {
            const newValues = selectedValues.includes(value)
                ? selectedValues.filter(v => v !== value)
                : [...selectedValues, value];
            const selectedOptions = options.filter(opt => newValues.includes(opt.value)).map(opt => {
              return opt.value;
            }).join(',');
            pushInfoToGoogleData({
                event: 'item_selected',
                data: {
                    stepId,
                    stepIndex,
                    cardTitle,
                    selected_options: selectedOptions
                }
            });
            facebookEventFire('ItemSelected', {
                customData: { stepId, stepIndex, cardTitle, selected_options: selectedOptions
              },
                userData: {}
            })
            onSelect(newValues);
        } else {
            pushInfoToGoogleData({
                event: 'item_selected',
                data: {
                    stepId,
                    stepIndex,
                    cardTitle,
                    selected_options: options.filter(opt => [value].includes(opt.value)).map(opt => {
                        return opt.value
                    }).join(',')
                }
            })
            facebookEventFire('ItemSelected', {
              customData: { stepId, stepIndex, cardTitle, selected_options: options.filter(opt => [value].includes(opt.value)).map(opt => {
                return opt.value
              }).join(',')
              },
              userData: {}
            })
            onSelect([value]);
        }
    };

    return (
        <div className="quiz-selector">
            {options.map((option) => (
                <div
                    key={option.id}
                    className={`quiz-selector__option ${selectedValues.includes(option.value) ? 'quiz-selector__option--selected' : ''}`}
                    onClick={() => handleSelect(option.value)}
                >
                    {option.emoji && (
                        <span className="quiz-selector__emoji">{option.emoji}</span>
                    )}
                    <div className="quiz-selector__text">
                        <span className="quiz-selector__title">{option.title || option.text}</span>
                        {option.text && option.text !== option.title && (
                            <span className="quiz-selector__description">{option.text}</span>
                        )}
                    </div>
                    <div className="quiz-selector__checkbox">
                        {selectedValues.includes(option.value) && (
                            <div className="quiz-selector__checkbox-inner" />
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};
